import * as React from "react";
import type { SVGProps } from "react";
const SvgPaid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <circle cx={8} cy={8} r={7} fill="#D6DBE7" />
    <path
      fill="#041E78"
      d="M5.667 9.6h3.666a.3.3 0 0 0 .236-.117.44.44 0 0 0 .098-.283.44.44 0 0 0-.098-.283.3.3 0 0 0-.236-.117H6.667c-.442 0-.866-.21-1.179-.586A2.22 2.22 0 0 1 5 6.8c0-.53.176-1.04.488-1.414.313-.375.737-.586 1.179-.586h.666V4h1.334v.8h1.666v1.6H6.667a.3.3 0 0 0-.236.117.44.44 0 0 0-.098.283c0 .106.035.208.098.283a.3.3 0 0 0 .236.117h2.666c.442 0 .866.21 1.179.586.312.375.488.884.488 1.414s-.176 1.04-.488 1.414c-.313.375-.737.586-1.179.586h-.666v.8H7.333v-.8H5.667z"
    />
  </svg>
);
export default SvgPaid;
